import React, { useState } from 'react';
import styled from 'styled-components';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { SegmentedControl } from '../../../CommonComponents/OPL/SegmentedControl/SegmentedControl';
import { PageWrapper } from '../../../CommonComponents/PageWrapper/PageWrapper';
import { DesktopWidgets } from '../../components/DesktopWidgets/DesktopWidgets';
import { MobileHeader } from '../../components/MobileHeader/MobileHeader';
import { PeriodSelector } from '../../components/PeriodSelector/PeriodSelector';
import { TabSlug } from '../../types';
import { GainLossMobile } from './Components/GainLossMobile/GainLossMobile';

export const MobileWrapper = styled(Box)({
  marginBottom: 32,
});

interface Props {
  selectedItemName: string;
  updatedAt: string;
}

export enum GainLossTab {
  Unrealized = 0,
  Realized = 1,
}

const GainLoss = ({ selectedItemName, updatedAt }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  const [currentTabIndex, setCurrentTabIndex] = useState<GainLossTab>(GainLossTab.Unrealized);
  const tabMap = [
    {
      name: 'Unrealized Gain Loss',
      slug: TabSlug.UnrealizedGainLoss,
    },
    {
      name: 'Realized Gain Loss',
      slug: TabSlug.RealizedGainLoss,
    },
  ];

  const Wrapper = isEmbeddedMobile ? MobileWrapper : PageWrapper;

  return (
    <Wrapper>
      {isEmbeddedMobile && (
        <Box mx="16" mb="12">
          <MobileHeader label={selectedItemName} subLabel={`Last updated: ${updatedAt}`} />
        </Box>
      )}

      <SegmentedControl
        id="default"
        values={tabMap.map(({ name }) => name)}
        selectedIndex={currentTabIndex}
        onChange={setCurrentTabIndex}
        ariaLabel="Select gain loss type"
        my="12"
        mx={isEmbeddedMobile ? '16' : 0}
      />

      {isEmbeddedMobile && (
        <Box px="16" mt="12">
          <PeriodSelector isVerticalLayout={isEmbeddedMobile} />
        </Box>
      )}

      {isEmbeddedMobile ? (
        <GainLossMobile tab={tabMap[currentTabIndex].slug} />
      ) : (
        <DesktopWidgets tab={tabMap[currentTabIndex].slug} />
      )}
    </Wrapper>
  );
};

export default GainLoss;
